import React from 'react';

import { SVGComponentProps } from './svg.types';

const AnalyticsSVG = ({
  stroke = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSVGProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSVGProps}
      >
        <path
          d="M22 13V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H13"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.33008 14.49L9.71008 11.4C10.0501 10.96 10.6801 10.88 11.1201 11.22L12.9501 12.66C13.3901 13 14.0201 12.92 14.3601 12.49L16.6701 9.51001"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.4802 15.82L19.7602 16.39C19.9002 16.67 20.2502 16.93 20.5602 16.99L20.9402 17.05C22.0802 17.24 22.3502 18.08 21.5302 18.91L21.1802 19.26C20.9502 19.5 20.8202 19.96 20.8902 20.28L20.9402 20.49C21.2502 21.87 20.5202 22.4 19.3202 21.68L19.0602 21.53C18.7502 21.35 18.2502 21.35 17.9402 21.53L17.6802 21.68C16.4702 22.41 15.7402 21.87 16.0602 20.49L16.1102 20.28C16.1802 19.96 16.0502 19.5 15.8202 19.26L15.4702 18.91C14.6502 18.08 14.9202 17.24 16.0602 17.05L16.4402 16.99C16.7402 16.94 17.1002 16.67 17.2402 16.39L17.5202 15.82C18.0602 14.73 18.9402 14.73 19.4802 15.82Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export default AnalyticsSVG;
